import { stringify } from 'querystring';

import { Topic } from '@ms/yammer-data/dist/state/types';

import { GetBaseUrlProps, getBaseUrl } from '../location/getBaseUrl';

type TopicPage = (topicId: Topic['id']) => string;

export const topicsFilterByKey = 'filterBy';

export const topicNetworkQuestionPrefix = '/topics-network-question';
export const topicNetworkQuestionBrowsePage = '/topics-network-question/browse';

const topicIdParam = ':topicId';
const replaceTopicId = (path: string, topicId: Topic['id']) => path.replace(topicIdParam, topicId);

export const topicsRootPath = '/topics';
export const topicParentSubpath = '/:topicId';
export const topicParentPath: `${typeof topicsRootPath}${typeof topicParentSubpath}` = `${topicsRootPath}${topicParentSubpath}`;
export const topicPage: TopicPage = (topicId) => replaceTopicId(topicParentPath, topicId);

export const topicFeedAllSubpath = '/all';
export const topicFeedAllPath: `${typeof topicParentPath}${typeof topicFeedAllSubpath}` = `${topicParentPath}${topicFeedAllSubpath}`;
export const topicFeedAllPage: TopicPage = (topicId) => replaceTopicId(topicFeedAllPath, topicId);

export const topicFeedConversationsSubpath = '/conversations';
export const topicFeedConversationsPath: `${typeof topicParentPath}${typeof topicFeedConversationsSubpath}` = `${topicParentPath}${topicFeedConversationsSubpath}`;
export const topicFeedConversationsPage: TopicPage = (topicId) => replaceTopicId(topicFeedConversationsPath, topicId);

export const topicFeedConversationsUnseenSubpath = '/conversations-unseen';
export const topicFeedConversationsUnseenPath: `${typeof topicParentPath}${typeof topicFeedConversationsUnseenSubpath}` = `${topicParentPath}${topicFeedConversationsUnseenSubpath}`;
export const topicFeedConversationsUnseenPage: TopicPage = (topicId) =>
  replaceTopicId(topicFeedConversationsUnseenPath, topicId);

export const topicFeedQuestionsSubpath = '/questions';
export const topicFeedQuestionsPath: `${typeof topicParentPath}${typeof topicFeedQuestionsSubpath}` = `${topicParentPath}${topicFeedQuestionsSubpath}`;
export const topicFeedQuestionsPage: TopicPage = (topicId) => replaceTopicId(topicFeedQuestionsPath, topicId);

export const topicFeedQuestionsUnseenSubpath = '/questions-unseen';
export const topicFeedQuestionsUnseenPath: `${typeof topicParentPath}${typeof topicFeedQuestionsUnseenSubpath}` = `${topicParentPath}${topicFeedQuestionsUnseenSubpath}`;
export const topicFeedQuestionsUnseenPage: TopicPage = (topicId) =>
  replaceTopicId(topicFeedQuestionsUnseenPath, topicId);

export const topicFeedQuestionsUnresolvedSubpath = '/questions-unresolved';
export const topicFeedQuestionsUnresolvedPath: `${typeof topicParentPath}${typeof topicFeedQuestionsUnresolvedSubpath}` = `${topicParentPath}${topicFeedQuestionsUnresolvedSubpath}`;
export const topicFeedQuestionsUnresolvedPage: TopicPage = (topicId) =>
  replaceTopicId(topicFeedQuestionsUnresolvedPath, topicId);

type TopicNetworkQuestionBrowsePageWithFilterParameter = (filterBy: string | undefined) => string;
export const topicNetworkQuestionBrowsePageWithFilterParameter: TopicNetworkQuestionBrowsePageWithFilterParameter = (
  filterKey
) => `${topicNetworkQuestionBrowsePage}${makeQueryStringWithFilterBy(filterKey)}`;

type MakeQueryStringWithFilterBy = (filterBy: string | undefined) => string;
export const makeQueryStringWithFilterBy: MakeQueryStringWithFilterBy = (filterBy) => {
  const filterByParameter = { [topicsFilterByKey]: filterBy };

  return `?${stringify(filterByParameter)}`;
};

type TopicPageUrl = (topic: Topic['id'], host: GetBaseUrlProps['host']) => string;
export const topicPageUrl: TopicPageUrl = (topicId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${topicPage(topicId)}`;
};
